import Vue from 'vue'
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from "socket.io-client";
import store from '@/state/store'

let socket;

export async function connectSocket() {
    const token = await JSON.parse(localStorage.getItem('authToken'));

    socket = io(process.env.VUE_APP_SOCKET, {
        transports: ['websocket'],
        auth: {
            token,
        },
        reconnection: true,
        reconnectionAttempts: 3,
        reconnectionDelay: 1000,
    });


    Vue.use(VueSocketIOExt, socket, { store });


    return socket;
}

export function disconnectSocket() {
    if (socket) socket.disconnect();
}
